import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { TextField, SelectField, Option } from '@johnlewispartnership/wtr-ingredients/dist/Forms';
import { Typography } from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import { EMAIL_FIELD, FULL_NAME_FIELD, PHONE_FIELD } from '../../../../components/CompetitionsForms/constants';
import styles from '../../CompetitionsForm.module.scss';
const DetailsSection = ({ form: { errors, register } }) => {
    var _a, _b, _c, _d;
    return (React.createElement("div", { className: classNames(styles.sectionWrapper, styles.spacerLarge), "data-testid": "details-section" },
        React.createElement(Typography, { styleAs: "sectionHeadingLight", element: "h3" }, "Your details"),
        React.createElement("div", { className: styles.titleField, "data-cs-mask": true },
            React.createElement(SelectField, { id: "title", label: "Title", name: "title", errorText: (_a = errors.title) === null || _a === void 0 ? void 0 : _a.message, ref: register({ required: 'Please select a value' }), placeholder: "" },
                React.createElement(Option, { value: "Mr" }, "Mr"),
                React.createElement(Option, { value: "Mrs" }, "Mrs"),
                React.createElement(Option, { value: "Miss" }, "Miss"),
                React.createElement(Option, { value: "Ms" }, "Ms"),
                React.createElement(Option, { value: "xMx" }, "Mx"),
                React.createElement(Option, { value: "Dr" }, "Dr"),
                React.createElement(Option, { value: "Lord" }, "Lord"),
                React.createElement(Option, { value: "Lady" }, "Lady"),
                React.createElement(Option, { value: "Prof" }, "Prof"),
                React.createElement(Option, { value: "Reverend" }, "Reverend"),
                React.createElement(Option, { value: "Sir" }, "Sir"))),
        React.createElement(TextField, { errorText: (_b = errors.fullName) === null || _b === void 0 ? void 0 : _b.message, id: "full-name", label: "Full name", name: "fullName", ref: register(FULL_NAME_FIELD) }),
        React.createElement(TextField, { errorText: (_c = errors.email) === null || _c === void 0 ? void 0 : _c.message, id: "email-address", label: "Email address", name: "email", ref: register(EMAIL_FIELD) }),
        React.createElement(TextField, { errorText: (_d = errors.phone) === null || _d === void 0 ? void 0 : _d.message, id: "phone-number", label: "Phone number", name: "phone", ref: register(PHONE_FIELD) })));
};
DetailsSection.propTypes = {
    form: propTypes.shape({
        errors: propTypes.objectOf(propTypes.shape({
            ref: propTypes.shape({ scrollIntoView: propTypes.func, focus: propTypes.func }),
            type: propTypes.string,
            message: propTypes.string,
        })),
        register: propTypes.func.isRequired,
    }).isRequired,
};
export default DetailsSection;
//# sourceMappingURL=index.js.map